/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_DeletedInputs */

const cs_blog_deleted = /** @type {(inputs: Blog_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Článek smazán`)
};

const en_blog_deleted = /** @type {(inputs: Blog_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Article deleted`)
};

/**
* | output |
* | --- |
* | "Article deleted" |
*
* @param {Blog_DeletedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_deleted = /** @type {((inputs?: Blog_DeletedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_DeletedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_deleted(inputs)
	return cs_blog_deleted(inputs)
});